import { useState, useRef, useEffect } from 'react';
import {
  AdvancedDetails,
  CloseButton,
  Content,
  Header,
  HeaderTitle,
  NewChamadoContainer,
  StyledFormGroup,
  StyledFormRadio,
  StyledInnerGridColumn,
  StyledInnerFormGroup,
  StyledSelect,
  TransparentBg,
  SaveButton,
  ErrorText,
  SuccessModal,
  SubLabel,
  SubLabelMobile,
} from './styled';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as CheckedIcon } from 'assets/icons/checked-icon-orange.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close-gray.svg';
import { ReactComponent as SuccessIcon } from 'assets/icons/success-checkmark.svg';
import { ReactComponent as OpenIcon } from 'assets/icons/open-icon-gray.svg';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { Controller, useForm, FormProvider } from 'react-hook-form';
//import { Radio } from './subcomponents/Radio';
import { Textarea } from 'components/Form/subcomponents/Textarea';
import ImageUpload from './subcomponents/ImageUpload';
import { isMobile } from 'react-device-detect';
import InputMask from 'react-input-mask';
import { AdvancedDetailModal } from './subcomponents/AdvancedDetailsModal';
import Checkbox from './subcomponents/Checkbox';
import { createErrorToast, createGenericErrorToast } from 'utils/createToast';
import { useCookies } from 'react-cookie';
import { FiltersService } from 'services/reports';
import { RegistrationService } from 'services/main/endpoints/RegistrationService';
import { Toast } from 'components/Toast';
import * as Sentry from '@sentry/react';
import { handleImageUpload } from 'utils/imageUpload';
import { ChamadoService } from 'services/main/endpoints/ChamadoService';
import { Button } from 'components/Button';
import { RadioButton } from './subcomponents/ButtonRadio';
import { GenericTooltip } from 'components/Tooltip/NoIconTooltip';

const MAX_FILE_SIZE = 15 * 1024 * 1024;

export const NovoChamado = ({ setOpenNewChamadoModal, values, updateTable }) => {
  const [cookie] = useCookies();
  const [disableButton, setDisableButton] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [openAdvancedModal, setOpenAdvancedModal] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [hasOnlyUnitsWithSubgroup, setHasOnlyUnitsWithSubgroup] = useState(true);
  const [fields, setFields] = useState();
  const textAreaRef = useRef(null);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [companyConfig, setCompanyConfig] = useState({});
  const methods = useForm({
    defaultValues: {
      unit: '',
      problemType: '',
      problemRadioType:
        cookie?.qrcodeFilters?.type === 'E' ? 'equipamento' : cookie?.qrcodeFilters?.type === 'A' ? 'ambiente' : '',
      problem: '',
      details: '',
      nome: '',
      telefone: '',
      images: [],
      areaGroup: '',
      areaSubGroup: '',
      area: '',
      observation: '',
      equipment: '',
      receiveEmail: true,
      whatsappContact: true,
    },
    shouldUnregister: false,
  });
  const {
    control,
    //register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = methods;
  const advancedType1 = watch('problemRadioType');
  const handleSaveModal = data => {
    setModalData(data);
    methods.setValue('modalData', data);
  };
  const checkAdvancedIsRequired = () => {
    const values = getValues();
    if (companyConfig.grupoAreaObrigatorio && !values.areaGroup) {
      createErrorToast(setToastList, `Preencha os campos no modal de Detalhamento Avançado`);
      return false;
    }

    if (companyConfig.subgrupoAreaObrigatorio && !values.areaSubGroup) {
      createErrorToast(setToastList, `Preencha os campos no modal de Detalhamento Avançado`);
      return false;
    }

    if (companyConfig.areaObrigatoria && !values.area) {
      createErrorToast(setToastList, `Preencha os campos no modal de Detalhamento Avançado`);
      return false;
    }

    if (companyConfig.equipamentoObrigatorio && !values.equipment) {
      createErrorToast(setToastList, `Preencha os campos no modal de Detalhamento Avançado`);
      return false;
    }
    return true;
  };
  const handleSave = async data => {
    Sentry.captureMessage('Salvar Chamado', {
      tags: { Empresa: cookie?.companies?.id },
    });
    setDisableButton(true);
    if (!checkAdvancedIsRequired()) return;
    const allData = { ...modalData, ...data };
    const { images } = data;
    const empresaId = cookie.companies?.id;
    const typicalOcurrence = filterTypicalOccurrence(data?.problem);
    const equipmentsData = filterEquipments(allData.equipment);
    const grupoAreadIdFiltered = filterGrupoArea(allData?.areaGroup);
    const subGrupoAreadIdFiltered = filterGrupoArea(allData?.areaSubGroup);
    const token = cookie.authToken;
    const now = new Date();
    let nameCount = {};
    const renamedImages = images.map(foto => {
      const originalName = foto?.name || 'image.jpg';
      const [name, ext] = originalName.split(/(?=\.[^.]+$)/);
      nameCount[originalName] = (nameCount[originalName] || 0) + 1;

      const count = nameCount[originalName];
      const newName = count > 1 ? `${name}${count}.${ext.slice(1)}` : originalName;

      return { file: foto, renamedName: newName };
    });

    const ocurrenceData = {
      empresaId,
      siteId: allData?.unit,
      tipoAnomalia: 19,
      descricao: allData?.details + ', ' + allData?.observation,
      dataRegistro: new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString(),
      anomaliaTipicaId: allData?.problem || null,
      grupoAreaId: grupoAreadIdFiltered != null ? grupoAreadIdFiltered[0]?.grupoAreaId : null, //allData?.areaGroup || null,
      subgrupoAreaId: subGrupoAreadIdFiltered != null ? subGrupoAreadIdFiltered[0]?.subGrupoArea : null,
      areaId: allData?.area || null,
      tipoEquipamentoId: equipmentsData != null ? equipmentsData[0]?.equipmentTypeId : null,
      equipamentoId: allData?.equipment || null,
      sistemaEmpresaId: allData?.problemType || null,
      prioridadeAnomaliaId: typicalOcurrence !== null ? typicalOcurrence[0]?.prioridadeAnomaliaId : null,
      observacao: allData?.observation,
      setorId: empresaId === '7014' ? 8741 : typicalOcurrence !== null ? typicalOcurrence[0]?.setorId : null,
      emitentes: [
        {
          emitenteId: cookie.chamadosAccess.userId,
          emailCadastro: allData?.receiveEmail,
          emailCorrecao: allData?.receiveEmail,
        },
      ],
      executores:
        typicalOcurrence !== null
          ? typicalOcurrence[0]?.executores.map(executor => ({
              executorId: executor.executor,
              emailCadastro: allData?.receiveEmail,
              emailCorrecao: allData?.receiveEmail,
            }))
          : [],
      fotos: renamedImages.map(({ renamedName }) => ({ fotoPath: renamedName })),
      temFoto: renamedImages.length > 0 ? true : false,
      plataforma: 1,
      indisponibilidade: false,
      permitirContato: allData?.whatsappContact,
    };
    try {
      images?.forEach(image => {
        if (image.size > MAX_FILE_SIZE) {
          Sentry.captureMessage('Chamado - arquivo excede 15Mb', {
            tags: { Empresa: cookie?.companies?.id },
          });
          createErrorToast(setToastList, `O arquivo excede o tamanho máximo permitido de 15Mb.`);
          throw new Error('O arquivo excede o tamanho máximo permitido de 15Mb.');
        }
      });
      const chamadoResponse = await ChamadoService.saveOccurences({
        EmpresaId: empresaId,
        UnidadeId: allData?.unit,
        data: ocurrenceData,
      });
      let telefoneResponse = null;

      if (allData?.telefone !== fields?.telefone) {
        telefoneResponse = await RegistrationService.saveChamadoUserInfo({
          EmpresaId: empresaId,
          nome: allData?.nome,
          email: fields?.email,
          celular: allData?.telefone,
          forceEmailConfirmation: false,
        });
      }
      if (
        chamadoResponse.data.success &&
        ((allData?.telefone !== fields?.telefone && telefoneResponse?.data?.success) ||
          allData?.telefone === fields?.telefone)
      ) {
        const fotosPaths = chamadoResponse.data.fotosResult.fotoCreatedPaths;
        const filesWithCloudPaths = renamedImages.map(file => ({
          file: file.file,
          cloudPath: fotosPaths[file.renamedName],
        }));
        try {
          if (images) {
            await Promise.all(
              filesWithCloudPaths.map(imageData =>
                handleImageUpload(imageData, 'AnomaliasFotos', empresaId, token, setToastList, cookie),
              ),
            );
          }
          setOpenModalSuccess(true);
          setDisableButton(false);
        } catch (error) {
          console.error('Erro ao fazer upload das imagens:', error.message);
          Sentry.captureException(error);
          setDisableButton(false);
          return;
        } finally {
          reset({
            unit: '',
            problemType: '',
            problemRadioType:
              cookie?.qrcodeFilters?.type === 'E'
                ? 'equipamento'
                : cookie?.qrcodeFilters?.type === 'A'
                ? 'ambiente'
                : '',
            problem: '',
            details: '',
            nome: '',
            telefone: '',
            images: [],
            areaGroup: '',
            areaSubGroup: '',
            area: '',
            observation: '',
            equipment: '',
            receiveEmail: true,
            whatsappContact: true,
          });
        }
      }
    } catch (error) {
      createGenericErrorToast(setToastList);
      console.error('Erro:', error);
      Sentry.captureException(error);
      setDisableButton(false);
    } finally {
      reset({
        unit: '',
        problemType: '',
        problemRadioType:
          cookie?.qrcodeFilters?.type === 'E' ? 'equipamento' : cookie?.qrcodeFilters?.type === 'A' ? 'ambiente' : '',
        problem: '',
        details: '',
        nome: '',
        telefone: '',
        images: [],
        areaGroup: '',
        areaSubGroup: '',
        area: '',
        observation: '',
        equipment: '',
        receiveEmail: true,
        whatsappContact: true,
      });
    }
  };
  const populateFieldsStrategy = async () => {
    const companyId = cookie?.companies?.id;
    const unitId = getValues('unit');
    const system = getValues('problemType');
    const grupoAreaId = getValues('areaGroup');
    const subGrupoAreaId = getValues('areaSubGroup');
    const equipment = filterEquipments(getValues('equipment'));
    const areaIds = getValues('area');
    return await Promise.all([
      FiltersService.getUnits({
        companyId,
      }),
      unitId &&
        FiltersService.getSystems({
          companyId,
          unitIds: unitId,
        }),
      unitId &&
        ChamadoService.getGrupoAreas({
          empresa: companyId,
          siteId: unitId,
        }),
      unitId &&
        ChamadoService.getSubGrupoAreas({
          empresa: companyId,
          siteId: unitId,
          grupoAreaId: grupoAreaId || null,
        }),
      unitId &&
        ChamadoService.getAreas({
          empresa: companyId,
          siteId: unitId,
          grupoAreaId: grupoAreaId || null,
          subGrupoAreaId: subGrupoAreaId || null,
        }),
      unitId &&
        ChamadoService.getEquipments({
          empresa: companyId,
          SiteId: unitId,
          AreaId: areaIds || null,
        }),
      unitId &&
        ChamadoService.getOcorrenciasTipicas({
          EmpresaId: companyId,
          UnidadeId: unitId,
          system,
          grupoAreaId,
          subGrupoAreaId,
          tipoEquipamentoId: equipment?.equipmentTypeId,
        }),
    ]).then(values => ({
      units: values[0]?.data?.map(({ nome, site }) => ({
        label: nome,
        value: site,
      })),
      systems: values[1]?.data?.map(({ nome, sistemaEmpresa }) => ({
        label: nome,
        value: sistemaEmpresa,
      })),
      local: {
        areaGroup: values[2]?.data?.map(({ grupoArea, gid, agrupamento }) => ({
          label: agrupamento,
          value: gid,
          grupoAreaId: grupoArea,
        })),
        areaSubGroups: values[3]?.data?.map(({ gid, nome, subGrupoArea }) => ({
          label: nome,
          value: gid,
          subGrupoArea,
        })),
        area: values[4]?.data?.map(({ area, nomeFormatted, ...rest }) => ({
          label: nomeFormatted,
          value: area,
          ...rest,
        })),
        equipment: values[5]?.data?.map(({ equipamento, nomeFormatted, ...rest }) => ({
          label: nomeFormatted,
          value: equipamento,
          ...rest,
        })),
      },
      typical: values[6]?.data?.map(({ descricao, anomaliaId, ...rest }) => ({
        label: descricao,
        value: anomaliaId,
        ...rest,
      })),
    }));
  };
  const checkUnitsSubgroup = (units, fields, unitSubgroups) => {
    const adaptedUnits = adaptReportsApiOptions(units);
    fields.sort((a, b) => {
      return a.value - b.value;
    });
    adaptedUnits.sort((a, b) => {
      return a.value - b.value;
    });
    if (fields.length === adaptedUnits.length) {
      let isEqual = false;
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].value === adaptedUnits[i].value) {
          isEqual = true;
        } else {
          isEqual = false;
          break;
        }
      }
      if (isEqual) {
        //setHasOnlyUnitsWithSubgroup(true);
        setValue('unitSubgroup', unitSubgroups[0].value);
        return adaptedUnits;
      } else {
        setHasOnlyUnitsWithSubgroup(false);
        setValue('unitSubgroup', '');
        return fields;
      }
    } else {
      setHasOnlyUnitsWithSubgroup(false);
      setValue('unitSubgroup', '');
      return fields;
    }
  };
  const checkUnitsGroup = (units, fields, unitGroups) => {
    const adaptedSubgroups = adaptReportsApiOptionsSubgroups(units);
    fields.sort((a, b) => {
      return a.value - b.value;
    });
    adaptedSubgroups.sort((a, b) => {
      return a.value - b.value;
    });
    if (fields.length === adaptedSubgroups.length) {
      let isEqual = false;
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].value === adaptedSubgroups[i].value) {
          isEqual = true;
        } else {
          isEqual = false;
          break;
        }
      }
      if (isEqual) {
        //setHasOnlyUnitsWithSubgroup(true);
        setValue('unitGroup', unitGroups[0].value);
        return adaptedSubgroups;
      } else {
        setValue('unitGroup', '');
        return fields;
      }
    } else {
      setValue('unitGroup', '');
      return fields;
    }
  };
  const getCompanyConfig = async () => {
    const response = await ChamadoService.getCompanyConfig({ empresaId: cookie.companies?.id });
    setCompanyConfig(response.data);
  };
  const populateFields = async () => {
    try {
      const fieldsData = await populateFieldsStrategy();
      await getCompanyConfig();
      const { unitSubgroups, unitGroups } = fieldsData;
      if (unitGroups?.length === 1) {
        const { data: subGroups } = await FiltersService.getUnitSubgroups({
          companyId: cookie?.companies?.id,
          unitGroupIds: unitGroups[0]?.value,
        });
        const checkedSubGroups = checkUnitsGroup(subGroups, fieldsData.unitSubgroups, unitGroups);
        fieldsData.unitSubgroups = checkedSubGroups;
      }
      if (unitSubgroups?.length === 1) {
        const { data: units } = await FiltersService.getUnits({
          companyId: cookie?.companies?.id,
          unitGroupIds: unitGroups[0]?.value,
          unitSubgroupIds: hasOnlyUnitsWithSubgroup ? unitSubgroups[0].value : '',
        });
        const checkedUnits = checkUnitsSubgroup(units, fieldsData.units, unitSubgroups);
        fieldsData.units = checkedUnits;
      }
      setFields(prevState => ({
        ...prevState,
        ...fieldsData,
      }));
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
    }
  };
  const getUserInfo = async () => {
    const EmpresaId = cookie.companies?.id;
    const userId = cookie.chamadosAccess.userId;
    const response = await RegistrationService.getChamadoUserInfo({ EmpresaId, id: userId });
    setFields(prevState => ({
      ...prevState,
      email: response?.data?.email,
      telefone: response.data?.celular,
    }));
    reset({
      ...getValues(),
      ...{
        nome: response.data?.nome || '',
        telefone: response.data?.celular || '',
      },
    });
  };
  const fetchData = async () => {
    try {
      await populateFields();
      await getUserInfo();
    } catch (err) {
      if (err.message.includes('Network Error')) {
        history.push('/conection-error');
      }

      createGenericErrorToast(setToastList);
    }

    if (!cookie?.companies?.id) {
      createErrorToast(setToastList, 'Selecione uma empresa para continuar');
      return;
    }
  };
  useEffect(() => {
    if ((values?.unidade || values?.ambiente || values?.equipamento) && !cookie?.qrcodeFilters) {
      reset({
        ...getValues(),
        ...{ unit: values?.unidade, area: values?.ambiente, equipment: values?.equipamento },
      });
      setIsUnitSelected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);
  const selectedUnit = watch('unit');
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 200);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData, cookie, selectedUnit]);
  const filterTypicalOccurrence = id => {
    if (id) return fields?.typical?.filter(({ value }) => value === id);
    return null;
  };
  const filterEquipments = id => {
    if (id) return fields?.local?.equipments?.filter(({ value }) => value === id);
    return null;
  };
  const filterGrupoArea = id => {
    if (id) return fields?.local?.areaGroup?.filter(({ value }) => value === id);
    return null;
  };
  const isDesktop = useMediaQuery({ minWidth: 1081 });
  const [isUnitSelected, setIsUnitSelected] = useState(false);
  const closeModals = () => {
    setOpenModalSuccess(false);
    setOpenNewChamadoModal(false);
    updateTable();
  };
  useEffect(() => {
    switch (cookie?.qrcodeFilters?.type) {
      case 'A':
        reset({
          ...getValues(),
          ...{
            unit: cookie?.qrcodeFilters?.site?.value,
            problemRadioType: 'ambiente',
            areaGroup: cookie?.qrcodeFilters?.newChamado?.grupoArea,
            areaSubGroup: cookie?.qrcodeFilters?.newChamado?.subGrupoArea,
            area: cookie?.qrcodeFilters?.newChamado?.area,
            receiveEmail: true,
            whatsappContact: true,
          },
        });
        setIsUnitSelected(true);
        break;
      case 'U':
        reset({
          ...getValues(),
          ...{
            unit: cookie?.qrcodeFilters?.site?.value,
            receiveEmail: true,
            whatsappContact: true,
          },
        });
        setIsUnitSelected(true);
        break;
      case 'E':
        reset({
          ...getValues(),
          ...{
            unit: cookie?.qrcodeFilters?.site?.value,
            problemRadioType: 'equipamento',
            areaGroup: cookie?.qrcodeFilters?.newChamado?.grupoArea,
            areaSubGroup: cookie?.qrcodeFilters?.newChamado?.subGrupoArea,
            area: cookie?.qrcodeFilters?.newChamado?.area,
            equipment: cookie?.qrcodeFilters?.equipamento?.valueNumber,
            receiveEmail: true,
            whatsappContact: true,
          },
          ...{ keepDirty: true },
        });
        setIsUnitSelected(true);
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [hasSelection, setHasSelection] = useState(false);
  useEffect(() => {
    const checkIfAdvancedModalHasSelectedValues = () => {
      const fields = [getValues('equipment'), getValues('area'), getValues('areaGroup'), getValues('areaSubGroup')];
      return fields.some(value => typeof value === 'number' || (typeof value === 'string' && value.trim() !== ''));
    };

    setHasSelection(checkIfAdvancedModalHasSelectedValues());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch(['equipment', 'area', 'areaGroup', 'areaSubGroup'])]);
  const cleanFilters = () => {
    setValue('unit', '');
    setValue('problemType', '');
    setValue('problemRadioType', '');
    setValue('problem', '');
    setValue('details', '');
    setValue('areaGroup', '');
    setValue('areaSubGroup', '');
    setValue('area', '');
    setValue('observation', '');
    setValue('equipment', '');
  };
  const selectedProblemType = watch('problemRadioType');
  const hasAnyRequiredConfig =
    companyConfig.grupoAreaObrigatorio ||
    companyConfig.subgrupoAreaObrigatorio ||
    companyConfig.areaObrigatoria ||
    companyConfig.equipamentoObrigatorio;
  return (
    <TransparentBg>
      <NewChamadoContainer>
        <Header>
          <HeaderTitle>Abrir um chamado</HeaderTitle>
          <CloseButton onClick={() => setOpenNewChamadoModal(false)}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <Content>
          <FormProvider {...methods}>
            {openAdvancedModal && (
              <AdvancedDetailModal
                type={advancedType1}
                onSave={handleSaveModal}
                setOpenAdvancedModal={setOpenAdvancedModal}
                fields={fields}
                fetchData={fetchData}
                companyConfig={companyConfig}
              />
            )}
            <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />

            <StyledFormGroup label="Fotos do problema" isRequired={companyConfig.fotoObrigatoria}>
              <ImageUpload inputName={'images'} isMobile={isMobile} isRequired={companyConfig.fotoObrigatoria} />
              {companyConfig.fotoObrigatoria && errors.images && <ErrorText>{errors.images.message}</ErrorText>}
            </StyledFormGroup>
            <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
            <StyledFormGroup label={'Qual a Unidade?'} isRequired>
              <Controller
                name="unit"
                defaultValue={''}
                control={control}
                rules={{ required: 'Selecione uma unidade' }}
                render={props => (
                  <>
                    <StyledSelect
                      {...props}
                      size={isDesktop ? 'large' : 'medium'}
                      placeholder="Selecionar"
                      options={fields?.units}
                      error={!!errors.unit}
                      onChange={value => {
                        cleanFilters();
                        setIsUnitSelected(!!value);
                        props.onChange(value);
                        //fetchData();
                      }}
                    />
                  </>
                )}
              />
              {errors.unit && <ErrorText>{errors.unit.message}</ErrorText>}
            </StyledFormGroup>
            <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
            {isUnitSelected && (
              <>
                <StyledFormGroup label={'O problema é em um...'} disabled={!isUnitSelected} isRequired>
                  <SubLabel>{'(Selecione onde ocorreu:)'}</SubLabel>
                  <SubLabelMobile>Selecione onde ocorreu:</SubLabelMobile>
                  <StyledFormRadio>
                    {!companyConfig.equipamentoObrigatorio && (
                      <RadioButton
                        text="Ambiente"
                        isActive={selectedProblemType === 'ambiente'}
                        onClick={() => setValue('problemRadioType', 'ambiente')}
                        width={'140px'}
                      />
                    )}
                    <RadioButton
                      text="Equipamento"
                      isActive={selectedProblemType === 'equipamento'}
                      onClick={() => setValue('problemRadioType', 'equipamento')}
                      width={'269px'}
                    />
                  </StyledFormRadio>
                  {selectedProblemType && (
                    <AdvancedDetails
                      disabled={advancedType1 === null}
                      hasSelection={hasSelection}
                      onClick={() => setOpenAdvancedModal(true)}
                    >
                      {hasSelection && <CheckedIcon className="first-icon" />}
                      Indicar local do chamado <OpenIcon />
                    </AdvancedDetails>
                  )}
                </StyledFormGroup>
                <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
              </>
            )}
            {selectedProblemType && (hasAnyRequiredConfig ? hasSelection : true) && (
              <>
                <StyledFormGroup
                  label="Qual é o tipo de serviço?"
                  disabled={!isUnitSelected}
                  isRequired={companyConfig.sistemaObrigatorio}
                >
                  <Controller
                    name="problemType"
                    defaultValue={''}
                    control={control}
                    rules={companyConfig.sistemaObrigatorio ? { required: 'Preenchimento obrigatório.' } : {}}
                    render={props => (
                      <>
                        <StyledSelect
                          {...props}
                          placeholder={fields?.system?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'}
                          error={!!errors.problemType}
                          options={fields?.systems}
                          disabled={fields?.systems?.length === 0}
                          onChange={value => {
                            props.onChange(value);
                            fetchData();
                          }}
                        />
                        {fields?.systems?.length === 0 && (
                          <GenericTooltip
                            text={'Não há itens para selecionar'}
                            bottom={isDesktop ? '56px' : '68px'}
                            left={isDesktop ? '375px' : '105px'}
                            afterTop={'26px'}
                            afterLeft={'117px'}
                            width={'235px'}
                            height={'36px'}
                            fontSize={'16px'}
                            textAlign={'center'}
                            lineHeight={'20px'}
                            containerLeft={'0px'}
                            containerTop={'40px'}
                            containerHeight={'48px'}
                          />
                        )}
                      </>
                    )}
                  />

                  {companyConfig.sistemaObrigatorio && errors.problemType && (
                    <ErrorText>{errors.problemType.message}</ErrorText>
                  )}
                </StyledFormGroup>
                <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
                <StyledFormGroup
                  label="Situação encontrada"
                  disabled={!isUnitSelected}
                  isRequired={companyConfig.anomaliaTipicaObrigatoria}
                >
                  <Controller
                    name="problem"
                    defaultValue={''}
                    control={control}
                    rules={companyConfig.anomaliaTipicaObrigatoria ? { required: 'Preenchimento obrigatório.' } : {}}
                    render={props => (
                      <>
                        <StyledSelect
                          {...props}
                          options={fields?.typical}
                          placeholder={fields?.typical?.length === 0 ? 'Não há itens para selecionar' : 'Selecionar'}
                          disabled={fields?.typical?.lenght === 0}
                        />
                        {fields?.typical?.length === 0 && (
                          <GenericTooltip
                            text={'Não há itens para selecionar'}
                            bottom={isDesktop ? '56px' : '68px'}
                            left={isDesktop ? '375px' : '105px'}
                            afterTop={'26px'}
                            afterLeft={'117px'}
                            width={'235px'}
                            height={'36px'}
                            fontSize={'16px'}
                            textAlign={'center'}
                            lineHeight={'20px'}
                            containerLeft={'0px'}
                            containerTop={'40px'}
                            containerHeight={'48px'}
                          />
                        )}
                      </>
                    )}
                  />

                  {companyConfig.anomaliaTipicaObrigatoria && errors.problem && (
                    <ErrorText>{errors.problem.message}</ErrorText>
                  )}
                </StyledFormGroup>
                <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
                <StyledFormGroup label="Conte mais detalhes" disabled={!isUnitSelected} isRequired>
                  <Controller
                    name="details"
                    defaultValue={''}
                    control={control}
                    rules={{ required: 'Preenchimento obrigatório.' }}
                    render={props => (
                      <Textarea
                        {...props}
                        ref={textAreaRef}
                        error={!!errors.details}
                        width={isDesktop ? '569px' : '299px'}
                        disabled={!isUnitSelected}
                        size={'custom'}
                        placeholder={'Escreva o que aconteceu'}
                        customStyle={{
                          padding: '12px',
                          resize: 'none',
                          overflow: 'scroll',
                          height: '120px',
                        }}
                      />
                    )}
                  />
                  {errors.details && <ErrorText>{errors.details.message}</ErrorText>}
                </StyledFormGroup>
                <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />

                <StyledFormGroup label="Deixe seu contato" disabled={!isUnitSelected}>
                  <StyledInnerGridColumn size={2} columnGap="1rem">
                    <StyledInnerFormGroup label="Nome" width={isDesktop ? '316px' : '299px'}>
                      <Controller
                        name="nome"
                        defaultValue={''}
                        control={control}
                        render={props => (
                          <InputMask placeholder="  " onChange={props.onChange} disabled {...props}></InputMask>
                        )}
                      />
                    </StyledInnerFormGroup>
                    <StyledInnerFormGroup
                      label="Telefone"
                      width={isDesktop ? '316px' : '299px'}
                      disabled={!isUnitSelected}
                    >
                      <Controller
                        name="telefone"
                        defaultValue={''}
                        control={control}
                        render={props => (
                          <InputMask
                            mask="(99) 99999-9999"
                            placeholder=" ( ) "
                            maskchar=" "
                            onChange={props.onChange}
                            {...props}
                          ></InputMask>
                        )}
                      />
                      <Controller
                        name="whatsappContact"
                        control={control}
                        defaultValue={true}
                        render={props => (
                          <Checkbox
                            onChange={props.onChange}
                            checked={props.value}
                            name="whatsappContact"
                            label="Permitir contato via WhatsApp"
                            ref={null}
                          />
                        )}
                      />
                      <Controller
                        name="receiveEmail"
                        control={control}
                        defaultValue={true}
                        render={props => (
                          <Checkbox
                            onChange={props.onChange}
                            checked={props.value}
                            name="receiveEmail"
                            label="Receber e-mails sobre atualizações deste chamado"
                            ref={null}
                          />
                        )}
                      />
                    </StyledInnerFormGroup>
                  </StyledInnerGridColumn>
                  <FieldRow marginBottom="10px" />
                  <SaveButton disabled={disableButton} onClick={handleSubmit(handleSave)}>
                    ENVIAR
                  </SaveButton>
                  <FieldRow marginBottom={isDesktop ? '40px' : '24px'} />
                </StyledFormGroup>
              </>
            )}
          </FormProvider>
        </Content>
      </NewChamadoContainer>
      <SuccessModal
        hasHeader
        title="Seu chamado foi aberto com sucesso"
        icon={<SuccessIcon />}
        size={{ width: '448px' }}
        success={true}
        open={openModalSuccess}
        closeModal={closeModals}
      >
        <p>Acompanhe o status pelo Ambiente de Chamados.</p>
        <Button theme="primary" onClick={closeModals}>
          Entendi
        </Button>
      </SuccessModal>
      <Toast toastList={toastList} autoDelete dismissTime={5000} />
    </TransparentBg>
  );
};
